<template>
  <component :is="buttonType" class="nabvar-btn text-xs-left" :class="classes" v-ripple v-bind="{ to: to === '' ? null : to  }">
    <v-container v-bind="{ [`grid-list-${size}`]: true }" fluid>
      <v-layout row wrap>
        <v-flex xs2 shrink v-if="icon || iconComponent">
            <v-icon v-if="icon" v-bind="{ [iconSize]: iconSize !== '' }" :class="{ 'white--text': active }">{{ icon }}</v-icon>
            <component v-else :is="iconComponent" :color="active ? '#FFFFFF' : 'rgba(0,0,0,.54)'" />
        </v-flex>
        <v-flex>
          <h4>
            <slot name="default"></slot>
          </h4>
        </v-flex>
      </v-layout>
    </v-container>
  </component>
</template>
<script>
import InboxOutIcon from './InboxOutIcon.vue';

export default {
  components: {
    InboxOutIcon,
  },
  props: {
    icon: {
      type: String,
      default: '',
    },
    iconComponent: {
      type: String,
      default: '',
    },
    size: {
      type: String,
      default: 'xs',
    },
    iconSize: {
      type: String,
      default: '',
    },
    to: {
      type: String,
      default: '',
    },
    active: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    buttonType() {
      return this.to === '' ? 'button' : 'router-link';
    },
    classes() {
      return [
        this.size,
        this.active ? 'k-orange-linear' : '',
      ];
    },
  },
};
</script>
<style scoped>
  .md {
    padding-top: .5em;
    padding-bottom: .5em;
  }
  .nabvar-btn {
    width: 100%;
    border: 1px solid rgb(211, 211, 211);
    border-radius: 4px;
  }
  a.nabvar-btn {
    color: #282828;
    display: block;
    position: relative;
    text-decoration: none;
  }
  .nabvar-btn:focus {
    outline: none;
  }
</style>





// WEBPACK FOOTER //
// src/components/chat_center_v2/Button.vue